var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"#832e5b","cursor":"pointer"},attrs:{"title":"View Applicant Details"},on:{"click":_vm.openModal}})])
}
var staticRenderFns = []

export { render, staticRenderFns }